import AnalysisLensHelperText from '@components/common/AnalysisLensHelperText'; // Import Helper Text
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

const CustomAnalysisTranscript = ({ summaryData }) => {
  if (!summaryData?.results) {
    return (
      <Card variant="outlined" sx={{ p: 0, width: '100%', marginTop: '20px' }}>
        <Box p={2} display="flex" justifyContent="center">
          Custom lens analysis data not available.
        </Box>
      </Card>
    );
  }

  const { results } = summaryData;

  return (
    <Card variant="outlined" sx={{ width: '100%', marginTop: '20px', overflow: 'hidden', p: 0 }}>
      {/* Header */}
      <Box px={2} py={1.5} bgcolor="grey.100" borderBottom={1} borderColor="divider">
        <Typography
          variant="h6"
          component="div"
          sx={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}
        >
          Custom Lens Analysis
          <AnalysisLensHelperText lensName="custom_lens" level="transcript" size="small" />
        </Typography>
      </Box>

      <CardContent sx={{ p: { xs: 1.5, md: 3 } }}>
        {/* Overall Summary */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            Overall Summary
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {results.summary || 'No summary provided.'}
          </Typography>
        </Box>

        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          Thematic Insights
        </Typography>

        <Divider sx={{ mb: 2 }} />

        {results.themes?.map((themeObj, index) => (
          <Accordion key={index} variant="outlined" sx={{ mb: 1 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ '& .MuiAccordionSummary-content': { alignItems: 'center', gap: 2 } }}
            >
              <Typography variant="subtitle2">{themeObj.theme}</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary', lineHeight: 1.7 }}>
                {themeObj.summary}
              </Typography>

              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Representative Quotes
              </Typography>

              <Stack spacing={1.5}>
                {themeObj.quotes.map((quote, qIndex) => (
                  <Paper
                    key={qIndex}
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      bgcolor: 'grey.50',
                      borderRadius: 2,
                      fontStyle: 'italic',
                      color: 'text.secondary',
                    }}
                  >
                    “{quote}”
                  </Paper>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          To view the overall analysis that created this artifact go to &apos;Analysis Results&apos;
          tab
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CustomAnalysisTranscript;
